module.exports = __webpack_public_path__ + "img/next-button.b8e850d6.png";